import editorOptions from "../utils/editor-options";
export default {
    computed: {
        editorOptions(){
            return editorOptions;
        }
    }
}